require('./bootstrap');

import 'vuetify/dist/vuetify.min.css';
import 'babel-polyfill';

import Vue from 'vue';
import VueRouter from 'vue-router';
import Vuetify from 'vuetify';
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';
import HeadNavbar from './components/HeadNavbarComponent.vue';
import AppFooter from './components/FooterComponent.vue';
import { routes } from './routes';
import { useLookupStore } from './stores/LookupStore';
import { createPinia, mapStores, PiniaVuePlugin } from 'pinia';
import { useUserStore } from './stores/UserStore';
import VueI18n from 'vue-i18n';
import { i18nMessages } from './i18n';
import { getLocale } from './services/locale.service';

Sentry.init({
  dsn: 'https://9827a9eb512842b2a342f73653256644@sentry.io/2357967',
  integrations: [new Integrations.Vue({Vue, attachProps: true, logErrors: true})],
});

// Vue.use(i18n)
Vue.use(PiniaVuePlugin);
Vue.use(Vuetify);
Vue.use(VueRouter);
Vue.use(VueI18n);


const i18n = new VueI18n(i18nMessages(getLocale()));

const pinia = createPinia()

const router = new VueRouter({
  routes,
  mode: 'history',
});

router.beforeEach(async (to, from, next) => {
  const userStore = useUserStore(pinia)
  await userStore.verifyIfSignedIn();
  next();
});

// - Filters -
Vue.filter('formatDate', function(value) {
  if (value) {
    return value.substring(0, 10);
  }
  return '';
});

new Vue({
  el: '#app',
  i18n,
  pinia,
  router,
  vuetify: new Vuetify({theme: {
    themes: {
      light: {
        primary: {
          base: '#d1bf89',
          darken1: '#b19f69',
        },
        secondary: '#D3B2B1',
        anchor: '#DF8A00'
        // secondary: colors.red.lighten4, // #FFCDD2
        // accent: colors.indigo.base, // #3F51B5
      },
      transparentlight: {
        primary: {
          base: '#fff'
        }
      },
      transparentdark: {
        primary: {
          base: '#000'
        }
      }
    },
  }}),
  components: {
    HeadNavbar,
    AppFooter
  },
  computed: {
    ...mapStores(useLookupStore)
  },
  created() {
    this.lookupStore.load(this.$i18n.t.bind(this.$i18n));
  }
});
